module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/zh-hans_6-bfce481ea8f85b148bd7c13dbb21db3e.jpg";